import { SearchPortfoliosQuery } from '@predium/client-graphql';
import { useEntitySearch } from '@/components/global-search/hooks/useEntitySearch';
import { getPortfolioItems } from '@/components/global-search/utils';
import { SEARCH_PORTFOLIOS } from '@/graphql/StatusQuoAnalysis.queries';

type Portfolio = SearchPortfoliosQuery['portfolio'][0];

const portfolioDataExtractor = (data: SearchPortfoliosQuery | undefined): Portfolio[] => data?.portfolio ?? [];

export function useSearchPortfolio(searchText: string) {
  const { data, loading, error } = useEntitySearch<SearchPortfoliosQuery, Portfolio>({
    query: SEARCH_PORTFOLIOS,
    dataExtractor: portfolioDataExtractor,
    searchText,
  });

  return {
    portfolios: getPortfolioItems(data),
    loading,
    error,
  };
}
